export class SetNeedRefreshingFundingProgramDetail {
  public static readonly type = '[Scholarship] Set needRefreshingFundingProgramDetail';
  constructor(public needRefreshingFundingProgramDetail: boolean) { }
}

export class SetNeedRefreshingFundingProgram {
  public static readonly type = '[Scholarship] Set needRefreshingFundingProgram';
  constructor(public needRefreshingFundingProgram: boolean) { }
}
